import { render, staticRenderFns } from "./SAAS_SERVICES.vue?vue&type=template&id=a173b9c4&"
import script from "./SAAS_SERVICES.vue?vue&type=script&lang=js&"
export * from "./SAAS_SERVICES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports